import React from 'react';
import { t } from 'ttag';
import classNames from 'classnames';

import { Image } from '@ui/Image';
import { Title } from '@ui/Title';
import { Button } from '@ui/Button';
import { useDesktopOrWider } from '@utils/mediaQuery';
import CloseIcon from '@svg/close.svg';

import s from './ProductAvailabilityFeedback.sss';

type Props = {
  name: string;
  imageSrc: string;
  onYes: () => void;
  onNo: () => void;
  onIgnore: () => void;
  compact?: boolean;
  className?: string;
};

export const ProductAvailabilityFeedback: React.FC<Props> = ({
  name,
  imageSrc,
  onYes,
  onNo,
  onIgnore,
  compact = false,
  className,
}) => {
  const desktopOrWider = useDesktopOrWider() && !compact;

  const closeButton = (
    <Button
      theme="text"
      className={s.close}
      onClick={onIgnore}
    >
      <CloseIcon
        className={s.closeIcon}
        width="20"
        height="20"
      />
    </Button>
  );
  return (
    <div className={
      classNames(
        s.root,
        { [s.compact]: compact },
        className,
      )
    }>
      <div className={s.product}>
        <Image
          className={s.image}
          src={imageSrc} />

        <div className={s.questionBlock}>
          <Title className={s.title} type="h6">{t`Чи був товар у наявності?`}</Title>
          <div className={s.productName}>{name}</div>
        </div>

        {!desktopOrWider && closeButton}
      </div>

      <div className={s.actionButtons}>
        <Button theme="secondary" onClick={onYes}>
          {t`Був`}
        </Button>
        <Button theme="secondary" onClick={onNo}>
          {t`Не було`}
        </Button>
      </div>

      {desktopOrWider && closeButton}
    </div>
  );
};
